import React, { useState, useEffect, useRef } from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Grid from '@mui/material/Grid';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import SongPositionPerformanceList from '../player/SongPositionPerformanceList';
import SongbookPositionRequestList from '../player/SongbookPositionRequestList';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';

function SelectSongbookPosition(props) {

  const [currentPos, setCurrentPos] = useState(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      props.onChoosePosition(currentPos);
    }
  };

  const handleChoosePosition = (pos) => {
    console.log(pos);
    setCurrentPos(pos);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus className="muvika-select-song-position-dialog" open={props.open} onClose={props.onClose}>
      <DialogTitle sx={{ background: "var(--bg-color) !important" }}>{TR.cm_select_song_pos}</DialogTitle>
      <DialogContent sx={{ background: "var(--bg-color) !important" }}>
        <SongbookPositionRequestList requests={props.requests} performances={props.performances} onChoosePosition={handleChoosePosition} />
      </DialogContent>
      <DialogActions sx={{ background: "var(--bg-color) !important" }}>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onChoosePosition(currentPos)}
          >OK</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SelectSongbookPosition;